import EntityDetails from '@/components/EntityDetails';
import EntityUsers from '@/components/EntityUsers';
import InvitationForm from '@/components/InvitationForm';
import EntityDetailsSkeleton from '@/components/skeletons/EntityDetailsSkeleton';
import EntityUsersSkeleton from '@/components/skeletons/EntityUsersSkeleton';
import { useAdminApi } from '@/hooks/useAdminApi';
import { setPageTitle } from '@/lib/appInsights';
import { AdministrationApiContextType } from '@/types/util.types';

function Admin() {
  const {
    entityInformation,
    users,
    allowedRoles,
    safelistedDomains,
    updateEntityInformation,
    inviteUserToEntity,
    inviteUserToEklipx,
  } = useAdminApi() as AdministrationApiContextType;

  const inviteUser = (email: string, firstName: string, lastName: string, roles?: string[]) => {
    if (roles && roles.length > 0) {
      inviteUserToEntity(email, firstName, lastName, roles);
    } else {
      inviteUserToEklipx(email, firstName, lastName);
    }
  };
  setPageTitle('Company Details');

  return (
    <div className='container mx-auto px-4 sm:px-0'>
      <div className='flex flex-col mt-4'>
        <h4 data-cy='admin-title'>Settings</h4>
        <div className='flex flex-row mb-8'>
          <div className=' w-1/4'>
            {entityInformation && allowedRoles && safelistedDomains ? (
              <div>
                <EntityDetails entity={entityInformation} saveEntity={updateEntityInformation} />
                <div className='mt-8'>
                  <InvitationForm
                    allowedRoles={allowedRoles}
                    safelistedDomains={safelistedDomains}
                    isEntityInvite={false}
                    inviteUser={inviteUser}
                  />
                </div>
              </div>
            ) : (
              <EntityDetailsSkeleton></EntityDetailsSkeleton>
            )}
          </div>
          <div className='ml-4 w-3/4'>
            {users.length > 0 && allowedRoles && safelistedDomains ? (
              <EntityUsers users={users} />
            ) : (
              <EntityUsersSkeleton></EntityUsersSkeleton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin;
